
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movie/[movieId]",
      function () {
        return require("private-next-pages/movie/[movieId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movie/[movieId]"])
      });
    }
  